import axios from 'axios';
import { API_BASE_URL } from '@/constants';
import { fetchAuthSession } from 'aws-amplify/auth'; // ← or: import { Auth } from 'aws-amplify';

const BaseService = axios.create({
  timeout: 60000,
  baseURL: API_BASE_URL
});

const unauthCode = [401];

BaseService.interceptors.request.use(
  async (config) => {
    if (typeof window === 'undefined') return config;
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    } catch (error: unknown) {
      const parsedError = error as Error;
      console.error('Error in request interceptor:', parsedError.message);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;

    if (response && unauthCode.includes(response.status)) {
      console.error('Unauthorized access - redirecting to login');
      //   const accessToken = await localStorage.getItem('accessToken');
    }

    return Promise.reject(error);
  }
);

export default BaseService;
